/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  // Inbox responses contain credentials scoped to the current administrator.
  // The account-wide persisted cache cannot establish that authorization.
  getFromCache() {
    return this.getFromNetwork();
  }

  refetchAndCommit() {
    return this.getFromNetwork();
  }

  // eslint-disable-next-line class-methods-use-this
  validateCacheKey() {
    return Promise.resolve(false);
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  getBaileysStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/baileys_status`);
  }

  connectBaileys(inboxId) {
    return axios.post(`${this.url}/${inboxId}/baileys_connect`);
  }

  getBaileysQr(inboxId) {
    return axios.get(`${this.url}/${inboxId}/baileys_qr`);
  }

  restartBaileys(inboxId) {
    return axios.post(`${this.url}/${inboxId}/baileys_restart`);
  }

  logoutBaileys(inboxId) {
    return axios.post(`${this.url}/${inboxId}/baileys_logout`);
  }

  clearBaileysSession(inboxId) {
    return axios.post(`${this.url}/${inboxId}/baileys_clear_session`);
  }
}

export default new Inboxes();
